// Internal-only diagnostics. Never part of ProjectQueryResponse or a public/BFF route.
import { z } from "zod";
const Base = z.object({
  canonicalizationVersion: z.literal(1), plannerPolicyVersion: z.literal(1),
  pathCount: z.number().int().min(0).max(4), maxDepth: z.number().int().min(0).max(2),
  directionCounts: z.object({ forward: z.number().int().min(0).max(4), reverse: z.number().int().min(0).max(4) }).strict(),
  strategies: z.array(z.enum(["ROOT_KEYSET", "INDEX_FILTER", "FORWARD_LOOKUP", "REVERSE_INDEX_BATCH"])).max(4),
  estimatedFanout: z.literal("UNKNOWN"), costClass: z.enum(["LOW", "MEDIUM", "HIGH", "REJECT"]),
  reasonCodes: z.array(z.enum(["ROOT_UNBOUNDED", "REVERSE_FANOUT_UNKNOWN", "COST_REJECTED", "SQL_BUDGET_EXCEEDED", "SCOPE_TOPOLOGY_LIMIT_EXCEEDED", "DEADLINE_EXCEEDED", "ACQUIRE_TIMEOUT", "MATERIALIZATION_LIMIT_EXCEEDED", "DEPENDENCY_UNAVAILABLE"])).max(8),
}).strict();
export const Explain = z.discriminatedUnion("mode", [
  Base.extend({ mode: z.literal("PLAN_ONLY"), sqlCount: z.literal(0) }).strict(),
  Base.extend({ mode: z.literal("EXECUTE"), sqlCount: z.number().int().min(0).max(32),
    observedFanoutBucket: z.enum(["ZERO", "ONE", "UP_TO_20", "OVER_LIMIT"]), timingsMs: z.object({ total: z.number().finite().min(0) }).strict(),
  }).strict(),
]);
export type Explain = z.infer<typeof Explain>;
